export type Auth0LoginProvider = "google" | "email" | "sms" | "unknown";

export function loginProviderFromAuth0Id(auth0Id: string): Auth0LoginProvider {
    if (auth0Id.startsWith("google-oauth2|")) {
        return "google";
    }
    if (auth0Id.startsWith("email|")) {
        return "email";
    }
    if (auth0Id.startsWith("sms|")) {
        return "sms";
    }
    return "unknown";
}
